import * as React from 'react';

const CruisesIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2">
    <path
      d="M2.80238 17.1103L4.81198 22.4692C5.03899 23.0746 5.54462 23.5328 6.16931 23.6994L8.8334 24.4098C9.0015 24.4547 9.17474 24.4774 9.34872 24.4774H9.84996C10.0358 24.4774 10.2207 24.4515 10.3994 24.4004L13.2858 23.5757C13.6113 23.4827 13.9551 23.4739 14.285 23.55L17.1732 24.2165L18.4298 24.396C18.8019 24.4492 19.1814 24.3964 19.5249 24.2437L21.1831 23.5068C21.2911 23.4588 21.4081 23.4339 21.5263 23.4339C21.8872 23.4339 22.2083 23.2048 22.3256 22.8635L24.324 17.0501C24.6926 15.9778 24.0968 14.8137 23.0114 14.4856L14.348 11.8664C13.9786 11.7547 13.5848 11.7523 13.2141 11.8594L4.11996 14.4866C3.00012 14.8101 2.3931 16.0189 2.80238 17.1103Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.17383 7.47656V12.9149C5.17383 13.5974 5.84252 14.0794 6.49006 13.8636L13.4818 11.533C13.6773 11.4678 13.8881 11.4646 14.0854 11.5238L20.3206 13.3944C20.9622 13.5869 21.6079 13.1064 21.6079 12.4366V7.47656C21.6079 6.92428 21.1602 6.47656 20.6079 6.47656H6.17383C5.62154 6.47656 5.17383 6.92428 5.17383 7.47656Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.3911 2C10.3911 1.44772 10.8388 1 11.3911 1H15.6517C16.204 1 16.6517 1.44772 16.6517 2V6.21717H10.3911V2Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1 24.9993C2.56515 24.9991 3.39361 23.4339 4.91288 23.4336C6.99974 23.4332 8.56489 25.5208 11.9561 23.9556C15.3472 22.3905 17.1732 25.5208 20.0427 23.9556C22.9121 22.3905 24.4773 24.9993 25.5207 24.9993"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default CruisesIcon;
